var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { ChevronRight } from "backpack-ui/dist/components/icon";
import schema from "backpack-ui/dist/utils/schema";
import * as cn from "classnames";
import * as React from "react";
import * as styles from "./styles.css";
var listMicroData = schema({
    itemType: "BreadcrumbList",
});
var itemMicroData = schema({
    itemProp: "itemListElement",
    itemType: "ListItem",
});
var schemaItemType = {
    lodging: "Thing",
    partner_activity: "Thing",
    place: "Place",
    poi: "Thing",
};
var linkMicroData = function (link) {
    if (link && link.type) {
        return schema({
            itemProp: "item",
            itemType: schemaItemType[link.type],
        });
    }
    return schema({
        itemProp: "item",
        itemType: "Thing",
    });
};
var Breadcrumbs = function (_a) {
    var links = _a.links, className = _a.className;
    var items = links.map(function (link, index) { return (React.createElement("span", __assign({ className: styles.breadcrumbsItem, key: link.href, "data-placeType": link.placeType }, itemMicroData),
        React.createElement("a", __assign({ href: "//www.lonelyplanet.com" + link.href, key: link.href }, linkMicroData(link)),
            React.createElement("span", { itemProp: "name" }, link.title)),
        index < links.length - 1 &&
            React.createElement(ChevronRight, { width: 6 / 14 + "em", height: 6 / 14 + "em" }),
        React.createElement("meta", { itemProp: "position", content: "" + (index + 1) }))); });
    return (React.createElement("nav", __assign({ className: cn(styles.breadcrumbs, className) }, listMicroData), items));
};
export default Breadcrumbs;



//////////////////
// WEBPACK FOOTER
// ./app/shared/patterns/breadcrumbs/index.tsx
// module id = 8SFv
// module chunks = 2